// Chantier : Lot 2 - Acceptation CGU (PLAN/LEGAL/spec_pages_legales.md TK-PL4)
// Regle metier : RGPD-R01 / RGPD-R02 (PRODUIT/domaine/19_donnees_personnelles.md)
// Decision : D-RGPD-05 (PRODUIT/decisions/)
// Acces a la table cgu_acceptations. La RLS garantit le scope par utilisateur (lecture/insert
// de ses propres lignes). hasAcceptedCurrentCgu alimente le gate AuthLayout ; acceptCgu insere
// l'acceptation de la version courante avec le hash du texte (preuve).
import { supabase } from '@/lib/supabase';
import { CGU_VERSION, computeCguHash } from '@/lib/cgu';

export async function hasAcceptedCurrentCgu(userId: string): Promise<boolean> {
  const { count, error } = await supabase
    .from('cgu_acceptations')
    .select('id', { count: 'exact', head: true })
    .eq('user_id', userId)
    .eq('version', CGU_VERSION);
  if (error) throw error;
  return (count ?? 0) > 0;
}

export async function acceptCgu(userId: string): Promise<void> {
  const contentHash = await computeCguHash();
  const { error } = await supabase
    .from('cgu_acceptations')
    .upsert(
      { user_id: userId, version: CGU_VERSION, content_hash: contentHash },
      { onConflict: 'user_id,version', ignoreDuplicates: true }
    );
  if (error) throw error;
}
